import React from "react";

/**
 * StepCounter — issue #750 § 5.2. The text that fills `TopBar`'s
 * `rightLabel` slot: "Step 1 of 3", "Step 1 of 3 · add a ground", "Step 1
 * of 2". Deliberately no progress bar — the approved log-match flow (#757,
 * #758, #759) has none.
 *
 * `tone` defaults to the sky colour `TopBar`'s navy variant calls for;
 * pass `tone="navy"` when placed on the white top bar. `tone` only applies
 * to the default `variant="caption"` — see below.
 *
 * PR #777 review, F1. `variant="eyebrow"` is a SECOND drawn treatment for
 * this same text, added when #754 needed the label placed in the PAGE BODY
 * rather than in `TopBar`'s `rightLabel` slot (`SetUp.dc.html:76`: 10px/
 * 700/0.18em/uppercase, `#64748B`, i.e. `.nw-eyebrow` at `--nw-ink-muted`
 * — the "slate" R-003 asks for, not `.nw-caption`'s 12px/600 sentence case
 * navy/sky this component started with). `tone` is ignored in this variant
 * — every drawn body-placed instance of this label uses the same muted
 * colour, so there is nothing for a caller to choose. This is an addition,
 * not a replacement: every existing `rightLabel` caller keeps the original
 * `variant="caption"` behaviour untouched.
 */
export function StepCounter({
  step,
  total,
  label = null,
  tone = "sky",
  variant = "caption",
  className = "",
  "data-testid": testId,
  ...rest
}) {
  const text = `Step ${step} of ${total}${label ? ` · ${label}` : ""}`;

  if (variant === "eyebrow") {
    return (
      <span data-testid={testId} className={`nw-eyebrow ${className}`} {...rest}>
        {text}
      </span>
    );
  }

  const color = tone === "navy" ? "var(--nw-navy)" : "var(--nw-sky)";
  return (
    <span
      data-testid={testId}
      className={`nw-caption ${className}`}
      style={{ color, whiteSpace: "nowrap" }}
      {...rest}
    >
      {text}
    </span>
  );
}

export default StepCounter;
